var _polygon, _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRaiseHandOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "17.15 8.9 15.07 10.99 15.07 11.67 17.15 11.67 17.15 8.9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.32,16.62l1.54-1.54c-.36-.67-.73-1.41-1.13-2.26l0-.07a.63.63,0,0,1,.22-.85.63.63,0,0,1,.85.23l1.11,1.93,2.65-2.64V6a.62.62,0,0,1,.62-.62.61.61,0,0,1,.61.62v4.15L13.84,8.1V4.7a.61.61,0,0,1,.61-.62.62.62,0,0,1,.62.62V6.86l2.14-2.13h-.06v0a2.69,2.69,0,0,0-5.1-1.2,2.77,2.77,0,0,0-.91-.17A2.7,2.7,0,0,0,8.44,6v4.86a2.7,2.7,0,0,0-4.58,2.86C4.37,14.81,4.85,15.77,5.32,16.62Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.39,7.67v6.65a5.6,5.6,0,0,1-5.59,5.6,4.87,4.87,0,0,1-4.38-2.28L7,19.11A6.8,6.8,0,0,0,12.8,22a7.69,7.69,0,0,0,7.67-7.68v-7A2.68,2.68,0,0,0,20.08,6Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1.1,
    y: 10.96,
    width: 26.19,
    height: 2.08,
    transform: "translate(-4.97 12) rotate(-45.02)",
    className: "raise-hand-off-line",
    fill: "#ff9300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaiseHandOff);
export default __webpack_public_path__ + "static/media/raise-hand-off.a97dcfd6e9422b72000d6a708d87f2fc.svg";
export { ForwardRef as ReactComponent };